/**
 * @file 関数：論理関数
 * @license Copyright 2021 OPExPARK Inc.
 */

/**
 * ユーザーエージェント
 */
const ua = navigator.userAgent.toLowerCase();

/**
 * ブラウザ名を返す
 */
const fnCheckBrowser = () => {
    // Edge
    if (ua.indexOf("edg") > 0) {
        return "edge";
    }
    // Chrome
    else if (ua.indexOf("chrome") > 0) {
        return "chrome";
    }
    // Safari
    else if (ua.indexOf("safari") > 0) {
        return "safari";
    }
    // 上記以外
    else {
        return "others";
    }
};

/**
 * デバイスがAndroidかどうか
 */
export const fnIsAndroid = () => {
    if (ua.indexOf("android") > 0) {
        return true;
    } else {
        return false;
    }
};

/**
 * デバイスがiPadかどうか
 */
export const fnIsIpad = () => {
    if (ua.indexOf("ipad") > 0) {
        return true;
    } else {
        return false;
    }
};

/**
 * デバイスがiPhoneかどうか
 */
export const fnIsIphone = () => {
    if (ua.indexOf("iphone") > 0) {
        return true;
    } else {
        return false;
    }
};

/**
 * ブラウザがSafariかどうか
 */
export const fnIsSafari = () => {
    if (fnCheckBrowser() === "safari") {
        return true;
    } else {
        return false;
    }
};

/**
 * タッチデバイスかどうか
 */
export const fnIsTouchDevice = () => {
    return (
        "ontouchstart" in window ||
        navigator.maxTouchPoints > 0 ||
        window.matchMedia("(pointer:coarse)").matches
    );
};
